(() => {
  const selector = '#update-cart[name="checkout"], .upcart-checkout-button';
  // The shared row-hiding rule also matches UpCart's plural items container.
  if (!document.getElementById('louve-shipaid-cart-style')) {
    const style = document.createElement('style');
    style.id = 'louve-shipaid-cart-style';
    style.textContent = `body ul.upcart-internal-cart-items.upcart-public-cart-items:has(a[href*="/products/shipaid-protection"]) { display: block !important; }`;
    document.head.appendChild(style);
  }
  const styles = `
    :host {
      font-family: var(--base-font-family, inherit);
      --cp-radius: var(--btn-border-radius, 3px) !important;
      --cp-text: rgb(var(--body-text-color, 23, 23, 23));
      --cp-primary-size: 14px !important;
      --cp-secondary-size: 13px !important;
    }
    button { font-family: inherit !important; }
    .cp-primary, .cp-secondary {
      font-weight: 500 !important;
      line-height: 1.4 !important;
      min-height: 44px !important;
      letter-spacing: var(--btn-letter-spacing, normal) !important;
      text-transform: var(--btn-text-transform, none) !important;
    }
    .cp-price { font-weight: 500; }
    button:focus-visible { outline: 2px solid currentColor; outline-offset: 3px; }
  `;

  function configure() {
    document.querySelectorAll('shipaid-widget-v2').forEach(widget => {
      if (!widget.hasAttribute('data-clone') && widget.getAttribute('data-selector') !== selector) {
        widget.setAttribute('data-selector', selector);
      }
      const currency = window.Shopify?.currency?.active;
      if (currency && widget.getAttribute('currency') !== currency) widget.setAttribute('currency', currency);
      const root = widget.shadowRoot;
      if (root && !root.querySelector('#louve-shipaid-style')) {
        const style = document.createElement('style');
        style.id = 'louve-shipaid-style';
        style.textContent = styles;
        root.appendChild(style);
      }
    });
  }

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => { scheduled = false; configure(); });
  }

  // Both runtimes emit cart reads; refresh native totals only when contents change.
  let signature;
  let refreshTimer;
  let mergeTimer;
  let refreshing = false;
  let queued = false;
  function finishRefresh() {
    clearTimeout(mergeTimer);
    refreshing = false;
    if (queued) scheduleRefresh();
  }
  function scheduleRefresh() {
    queued = true;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      if (refreshing) return;
      queued = false;
      refreshing = Boolean(document.querySelector('cart-form[data-ajax-update="true"]'));
      if (refreshing) mergeTimer = setTimeout(finishRefresh, 4000);
      document.dispatchEvent(new CustomEvent('on:cart:change'));
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
    }, 120);
  }
  document.addEventListener('on:cart:after-merge', finishRefresh);
  function handleCart(event) {
    const cart = event.detail?.cart;
    if (!Array.isArray(cart?.items)) return;
    const next = JSON.stringify([cart.total_price, cart.items.map(item => [item.key, item.quantity, item.final_line_price])]);
    if (next === signature) return;
    const first = signature === undefined;
    signature = next;
    if (first) return;
    scheduleRefresh();
  }
  document.addEventListener('shipaid:cart:updated', handleCart);
  document.addEventListener('cart:update', handleCart);
  document.addEventListener('shipaid:widget:loaded', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  configure();
})();
